

export const anneescolaire = '2025-2026'
export const colorProfExpert = "#83bb36"
export const secret: string = process.env.ENCRYPT_KEY ?? "";

